import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { addHttpParams, addPageSpecificationParameters, CrudService, ENVIRONMENT, PageSpecification, ReportOutputFormat, ReportRunService, ReportSpecification, ReportSpecificationService } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AssetsUserViewService extends CrudService<any, string> {
  servicePath: string = '/assetsuserview';
  constructor(protected http: HttpClient,
    @Inject(ENVIRONMENT) protected environment: any,
    private reportRunService: ReportRunService,
    private reportSpecificationService: ReportSpecificationService) {
    super(http, environment);
  }

  public exportByExtFiltersAction(filters: any, outputFormat: ReportOutputFormat, download: boolean, pageSpec: PageSpecification) {
    var httpParams = addHttpParams(filters);
    httpParams = addPageSpecificationParameters(pageSpec, httpParams);
    httpParams = this.reportRunService.reportGeneralHttpParams(outputFormat, download, httpParams);
    return this.reportRunService.reportAction(this.serviceBaseUrl + '/exportByExtFilters', httpParams);
  }

  public exportReportSpecification(): Observable<ReportSpecification> {
    return this.reportSpecificationService.get('assets-user-view-export');
  }
}





